var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SchemaFieldRelationSelector',{attrs:{"value":_vm.value,"schema-uuid":_vm.schemaUuid},on:{"update":function($event){return _vm.$emit('update', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }